export const ethUsdAggregatorAbi = [
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", internalType: "uint8", type: "uint8" }],
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "latestAnswer",
    outputs: [{ name: "", internalType: "int256", type: "int256" }],
  },
] as const
